<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 md7 xl8 text-left>
        <span
          style="font-family:opensansbold;font-size:20px;color:#4A3E3E;"
          class="text-capitalize"
        >Description</span>
      </v-flex>
      <v-flex md4></v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex xs12 md7 lg7 xl8>
        <v-layout wrap>
          <v-flex xs12 text-left>
            <span
              style="font-family:opensansbold;font-size:18px;color:#000000;"
              class="text-capitalize"
            >{{productData.productname}}</span>
          </v-flex>
          <v-flex xs12 text-justify>
            <span v-html="productData.description" style="line-height:1.1"></span>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md1>
        <v-divider vertical height="90%"></v-divider>
      </v-flex>
      <v-flex xs12 md3 lg3 xl3>
        <v-layout wrap>
          <v-flex xs12 text-left pt-2>
            <span style="font-family:opensansbold;font-size:13px;color:#000000;">Features & details</span>
          </v-flex>
          <v-flex v-for="(item,i) in productData.highlights" :key="i" xs12 text-left>
            <span style="font-family:opensansregular;font-size:12px;color:#000000;">{{item}}</span>
          </v-flex>
          <v-flex xs12 text-left pt-2>
            <span style="font-family:opensansbold;font-size:13px;color:#000000;">Product Information</span>
          </v-flex>
          <v-flex xs12>
            <v-layout v-for="(item,i) in productData.specifications" :key="i" wrap>
              <v-flex xs12 text-left>
                <span
                  style="font-family:opensanssemibold;font-size:13px;color:#000000;"
                >{{item.name}}</span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                  style="font-family:opensansregular;font-size:12px;color:#000000;"
                >{{item.value}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex xs12 text-left pt-2>
            <span style="font-family:opensanssemibold;font-size:13px;color:#000000;">Brand</span>
          </v-flex>
          <v-flex xs12 text-left>
            <span style="font-family:opensansregular;font-size:12px;color:#000000;">Bagrry's</span>
          </v-flex>-->
          <v-flex xs12 text-left pt-2>
            <span style="font-family:opensanssemibold;font-size:13px;color:#000000;">Ingredient Type</span>
          </v-flex>
          <v-flex xs12 text-center>
            <div style=" border-style: solid; border-width: 1px; border-color: #23B458;width:40px;">
              <span style="font-family:opensansregular;font-size:20px;color:#23B458;">●</span>
            </div>
          </v-flex>
          <v-flex xs12 text-left pt-2>
            <span style="font-family:opensanssemibold;font-size:13px;color:#000000;">Manufacturer</span>
          </v-flex>
          <v-flex xs12 text-left>
            <span
              style="font-family:opensansregular;font-size:12px;color:#000000;"
            >{{productData.manufacturer}}</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ["productData"],
  data() {
    return {};
  },
};
</script>